import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { PageHero, FeatureGrid, ContentSection, SEOContent, CTASection } from '../components/shared';
import { pageHeroImages } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const diagnostikFeatures = [
  {
    id: '2B1',
    title: 'Offenes MRT',
    description: 'Stressfreie Magnetresonanztomographie auch bei Platzangst.',
    image: '/images/MRT Detail.webp',
    link: '/leistungen/diagnostik/mrt'
  },
  {
    id: '2B2',
    title: 'EKG & Langzeit-EKG',
    description: 'Herzrhythmus und Herzfunktion zuverlässig messen.',
    image: '/images/Kardiologie.webp',
    link: '/leistungen/diagnostik/ekg'
  },
  {
    id: '2B3',
    title: 'Belastungs-EKG',
    description: 'Herzdiagnostik unter körperlicher Belastung.',
    image: '/images/belastungs_EKG.webp',
    link: '/leistungen/diagnostik/belastungs-ekg'
  },
  {
    id: '2B4',
    title: 'Ultraschall (Sonographie)',
    description: 'Schonende Bildgebung ohne Strahlenbelastung.',
    image: '/images/Ultraschall_neu.webp',
    link: '/leistungen/diagnostik/ultraschall'
  },
  {
    id: '2B5',
    title: 'Lungenfunktion',
    description: 'Atemwege und Lungenleistung zuverlässig prüfen.',
    image: '/images/LUNGE.webp',
    link: '/leistungen/diagnostik/lungenfunktion'
  },
  {
    id: '2B6',
    title: 'Labordiagnostik',
    description: 'Blut-, Urin- und Stuhluntersuchungen direkt vor Ort.',
    image: '/images/Labordiagnostik_neu.webp',
    link: '/leistungen/diagnostik/labor'
  },
  {
    id: '2B7',
    title: 'Langzeit-Blutdruck',
    description: 'Blutdruckwerte über 24 Stunden zuverlässig erfassen.',
    image: '/images/Content_Behandlung_9.webp',
    link: '/leistungen/diagnostik/blutdruck'
  }
];

export const DiagnostikPage = () => {
  return (
    <Layout>
      <PageHero
        title="Diagnostik-Zentrum im Medicum Diez"
        subtitle="Moderne Medizintechnik und schnelle Befunde direkt im Haus."
        backgroundImage={pageHeroImages.diagnostik}
        ctaText="Diagnostik-Termin buchen"
      />

      <FeatureGrid
        title="Unsere diagnostischen Leistungen"
        features={diagnostikFeatures}
        columns={4}
      />

      <ContentSection
        title="Schnelle Diagnostik direkt vor Ort"
        content="Im Diagnostik-Zentrum des Medicum Diez stehen moderne bildgebende und funktionelle Untersuchungsverfahren zur Verfügung. Befunde werden zeitnah ausgewertet und direkt mit Ihrem Hausarzt sowie den beteiligten Fachärzten besprochen."
        image="/images/MRT 5.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Enge Zusammenarbeit mit den Fachabteilungen"
        content={
          <div>
            <p className="text-[#0b382a]/80 leading-relaxed mb-4">
              Durch die räumliche Nähe zu Kardiologie, Radiologie und weiteren Fachrichtungen können Untersuchungen koordiniert und Therapieentscheidungen ohne Verzögerung getroffen werden.
            </p>
            <Link to="/leistungen/kardiologie" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
              Kardiologie & Herz-Check
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        }
        image="/images/Kardiologie 2.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <ContentSection
        title="Offenes MRT – auch bei Platzangst und Herzschrittmacher"
        content={
          <div>
            <p className="text-[#0b382a]/80 leading-relaxed mb-4">
              Unser Offenes MRT ermöglicht stressfreie Untersuchungen. In enger Abstimmung mit der Kardiologie sind in ausgewählten Fällen auch Untersuchungen bei Herzschrittmachern möglich.
            </p>
            <Link to="/leistungen/diagnostik/mrt" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
              Offenes MRT
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        }
        image="/images/MRT Detail.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Diagnostik in Diez und Limburg"
        content="Das Diagnostik-Zentrum im Medicum Diez bietet Offenes MRT, Ultraschall, EKG, Belastungs-EKG, Lungenfunktion, Labordiagnostik und Langzeit-Blutdruckmessung. Alle Untersuchungen werden fachübergreifend ausgewertet – für schnelle und sichere Diagnosen im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Diagnostik-Termin vereinbaren"
        subtitle="Vereinbaren Sie Ihren Untersuchungstermin online oder telefonisch."
        buttonText="Diagnostik-Termin buchen"
      />
    </Layout>
  );
};

export default DiagnostikPage;
